import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js"

export default class extends Controller {
  static values = {
    protectedCount: Number,
    unhealthyCount: Number,
    unmanagedCount: Number,
    incompatibleCount: Number,
    protectedUrl: String,
    unhealthyUrl: String,
    unmanagedUrl: String,
    incompatibleUrl: String
  }

  connect() {
    this.initializeChart()
  }

  initializeChart() {
    const canvas = this.element.querySelector("#defender-health-chart")
    if (!canvas) return

    new Chart(canvas, {
      type: "doughnut",
      data: this.chartData,
      options: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: true,
        onClick: (evt, activeElements) => {
          if (activeElements.length < 1) return

          const index = activeElements[0]._index
          const urls = [
            this.protectedUrlValue,
            this.unhealthyUrlValue,
            this.unmanagedUrlValue,
            this.incompatibleUrlValue
          ]
          if (urls[index]) {
            window.location.href = urls[index]
          }
        }
      }
    })
  }

  get chartData() {
    return {
      datasets: [{
        data: [
          this.protectedCountValue,
          this.unhealthyCountValue,
          this.unmanagedCountValue,
          this.incompatibleCountValue
        ],
        backgroundColor: ["#18BC9C", "#e74c3c", "#f39c12", "#6F42C1"]
      }],
      labels: ["Protected", "Unhealthy", "Unmanaged", "Incompatible"]
    }
  }
}
